<template>
  <div class="about">
    <h1>👨 om</h1>
    <p>Vaksinekalkulatoren er laga av <a href="https://olepetterstokke.no/">Ole Petter Baugerød Stokke</a>, som en Vue-test, etter at jeg måtte snu i døra på vaksinesenteret fordi jeg er elendig på tall og datoer.</p>
    <p>Det kan jo være interessant å vite for ekstremt spesielt interesserte.</p>
  </div>
</template>
